import { isHiddenSecurityRole } from 'module/settings/settingsGameMasterTabs/GeneralSetting/constants';

/** System role names hidden from all user-visible lists (in addition to HIDDEN_SECURITY_ROLES). */
const HIDDEN_SYSTEM_ROLE_NAMES: readonly string[] = ['Admin User', 'Support User'];

export const getUserSecurityRoleName = (user: any): string =>
	user?.securityRole?.name ||
	user?._raw?.securityRole?.name ||
	user?._raw?.security_role?.name ||
	user?._full?.securityRole?.name ||
	'';

/**
 * Returns true when a user should be excluded from workplace user pickers and lists.
 */
export const isHiddenFromUserLists = (user: any): boolean => {
	if (!user) return true;

	const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim().toLowerCase();
	const firstName = (user.firstName || '').toLowerCase();
	const lastName = (user.lastName || '').toLowerCase();
	const email = (user.email || '').toLowerCase();
	const roleName = getUserSecurityRoleName(user);

	if (
		roleName &&
		(isHiddenSecurityRole(roleName) || HIDDEN_SYSTEM_ROLE_NAMES.includes(roleName))
	) {
		return true;
	}

	const isAdminUser =
		fullName.includes('admin user') ||
		fullName === 'admin user' ||
		(firstName === 'admin' && lastName === 'user');

	const isSupportUser =
		fullName.includes('support user') ||
		fullName === 'support user' ||
		(firstName === 'support' && lastName === 'user');

	const hasAdminSupportEmail =
		email.includes('admin@') ||
		email.includes('support@') ||
		email.includes('@admin') ||
		email.includes('@support');

	const isHiddenUser =
		fullName.includes('hidden') ||
		email.includes('hidden') ||
		firstName === 'hidden' ||
		user._raw?.hidden === true ||
		user._raw?.isHidden === true;

	const isSeparated = user.separation === true || user._raw?.separation === true;

	return (
		isAdminUser ||
		isSupportUser ||
		hasAdminSupportEmail ||
		isHiddenUser ||
		isSeparated
	);
};

export const filterVisibleWorkplaceUsers = <T>(users: T[]): T[] =>
	users.filter((user) => !isHiddenFromUserLists(user));
